var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('table-medical-visit',{attrs:{"loading":_vm.loading,"headers":_vm.headers,"medical_visits":_vm.medical_visits,"page":_vm.current_page,"page-count":_vm.last_page,"items-per-page":_vm.per_page},on:{"pagination":_vm.getMedicalVisits}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }